module.exports = __webpack_public_path__ + "img/pou_tai_monastery_and_pou_tai_un_temple.d80a6387.jpg";